import { render, staticRenderFns } from "./checkdetail.vue?vue&type=template&id=8319e9fa&scoped=true"
import script from "./checkdetail.vue?vue&type=script&lang=ts"
export * from "./checkdetail.vue?vue&type=script&lang=ts"
import style0 from "./checkdetail.vue?vue&type=style&index=0&id=8319e9fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8319e9fa",
  null
  
)

export default component.exports